export default "__VITE_ASSET__CHo0YGKq__"